import React from "react";
import { FaCheck } from "react-icons/fa";

const STEPS = [
  { id: 1, label: "Mobile Verify" },
  { id: 2, label: "Personal Info" },
];

export default function AstrologerProgress({ currentStep, mobileVerified }) {
  return (
    <nav className="ao-progress" aria-label="Registration progress">
      {STEPS.map((step) => {
        const isComplete = step.id === 1 ? mobileVerified : currentStep > step.id;
        const isActive = currentStep === step.id;
        return (
          <div
            key={step.id}
            className={`ao-progress__step${isActive ? " is-active" : ""}${isComplete ? " is-complete" : ""}`}
          >
            <div className="ao-progress__dot" aria-current={isActive ? "step" : undefined}>
              {isComplete && !isActive ? <FaCheck size={11} aria-hidden /> : step.id}
            </div>
            <span className="ao-progress__label">{step.label}</span>
          </div>
        );
      })}
    </nav>
  );
}
